/// <amd-module name="TFS/Admin/Common/RestClient/Token" />
/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   vssf\client\webapi\httpclients\clientgeneratorconfigs\genclient.json
 */

import { IVssPageContext, IVssRestClient, IVssRestClientOptions, RestClients } from "VSS/Platform/Context";
import { RestClientBase } from "VSS/Platform/RestClientBase";

import * as Token from "TFS/Admin/Common/Contracts/Token";

export interface ITokenRestClient extends IVssRestClient {
    /**
     * @param accessTokenKey - 
     * @param isPublic - 
     */
    exchangeAccessTokenKey(accessTokenKey: string, isPublic?: boolean): Promise<Token.AccessToken>;
    /**
     * @param key - 
     * @param isPublic - 
     */
    getAccessToken(key?: string, isPublic?: boolean): Promise<Token.AccessToken>;
    /**
     * @param clientId - 
     * @param userId - 
     */
    issueAppSessionToken(clientId: string, userId?: string): Promise<Token.AppSessionTokenResult>;
    /**
     * @param appInfo - 
     */
    exchangeAppToken(appInfo: Token.AppTokenSecretPair): Promise<Token.AccessTokenResult>;
    /**
     * @param sessionToken - 
     * @param tokenType - 
     * @param isPublic - 
     * @param isRequestedByTfsPatWebUI - 
     */
    createSessionToken(sessionToken: Token.SessionToken, tokenType?: Token.SessionTokenType, isPublic?: boolean, isRequestedByTfsPatWebUI?: boolean): Promise<Token.SessionToken>;
    /**
     * @param authorizationId - 
     * @param isPublic - 
     */
    getSessionToken(authorizationId: string, isPublic?: boolean): Promise<Token.SessionToken>;
    /**
     * @param isPublic - 
     * @param includePublicData - 
     */
    getSessionTokens(isPublic?: boolean, includePublicData?: boolean): Promise<Token.SessionToken[]>;
    /**
     * @param displayFilterOption - 
     * @param createdByOption - 
     * @param sortByOption - 
     * @param isSortAscending - 
     * @param startRowNumber - 
     * @param pageSize - 
     * @param pageRequestTimeStamp - 
     * @param isPublic - 
     * @param includePublicData - 
     */
    getSessionTokensPage(displayFilterOption: Token.DisplayFilterOptions, createdByOption: Token.CreatedByOptions, sortByOption: Token.SortByOptions, isSortAscending: boolean, startRowNumber: number, pageSize: number, pageRequestTimeStamp: string, isPublic?: boolean, includePublicData?: boolean): Promise<Token.PagedSessionTokens>;
    /**
     * @param publicData - 
     * @param remove - 
     */
    removePublicKey(publicData: Token.SshPublicKey, remove: boolean): Promise<void>;
    /**
     */
    revokeAllSessionTokensOfUser(): Promise<void>;
    /**
     * @param authorizationId - 
     * @param isPublic - 
     */
    revokeSessionToken(authorizationId: string, isPublic?: boolean): Promise<void>;
}

class TokenRestClient extends RestClientBase implements ITokenRestClient {
    constructor(options: IVssRestClientOptions) {
        super(options);
    }

    /**
     * @param accessTokenKey - 
     * @param isPublic - 
     */
    public async exchangeAccessTokenKey(
        accessTokenKey: string,
        isPublic?: boolean
        ): Promise<Token.AccessToken> {

        const queryValues: any = {
            isPublic: isPublic
        };

        return this.beginRequest<Token.AccessToken>({
            apiVersion: "5.0-preview.1",
            method: "POST",
            routeTemplate: "_apis/Token/AccessTokens/{key}",
            queryParams: queryValues,
            body: accessTokenKey
        });
    }

    /**
     * @param key - 
     * @param isPublic - 
     */
    public async getAccessToken(
        key?: string,
        isPublic?: boolean
        ): Promise<Token.AccessToken> {

        const queryValues: any = {
            isPublic: isPublic
        };

        return this.beginRequest<Token.AccessToken>({
            apiVersion: "5.0-preview.1",
            routeTemplate: "_apis/Token/AccessTokens/{key}",
            routeValues: {
                key: key
            },
            queryParams: queryValues
        });
    }

    /**
     * @param clientId - 
     * @param userId - 
     */
    public async issueAppSessionToken(
        clientId: string,
        userId?: string
        ): Promise<Token.AppSessionTokenResult> {

        const queryValues: any = {
            clientId: clientId,
            userId: userId
        };

        return this.beginRequest<Token.AppSessionTokenResult>({
            apiVersion: "5.0-preview.1",
            method: "POST",
            routeTemplate: "_apis/Token/AppSessionTokens",
            queryParams: queryValues
        });
    }

    /**
     * @param appInfo - 
     */
    public async exchangeAppToken(
        appInfo: Token.AppTokenSecretPair
        ): Promise<Token.AccessTokenResult> {

        return this.beginRequest<Token.AccessTokenResult>({
            apiVersion: "5.0-preview.1",
            method: "POST",
            routeTemplate: "_apis/Token/AppTokenPairs",
            body: appInfo
        });
    }

    /**
     * @param sessionToken - 
     * @param tokenType - 
     * @param isPublic - 
     * @param isRequestedByTfsPatWebUI - 
     */
    public async createSessionToken(
        sessionToken: Token.SessionToken,
        tokenType?: Token.SessionTokenType,
        isPublic?: boolean,
        isRequestedByTfsPatWebUI?: boolean
        ): Promise<Token.SessionToken> {

        const queryValues: any = {
            tokenType: tokenType,
            isPublic: isPublic,
            isRequestedByTfsPatWebUI: isRequestedByTfsPatWebUI
        };

        return this.beginRequest<Token.SessionToken>({
            apiVersion: "5.0-preview.1",
            method: "POST",
            routeTemplate: "_apis/Token/SessionTokens/{authorizationId}",
            queryParams: queryValues,
            body: sessionToken
        });
    }

    /**
     * @param authorizationId - 
     * @param isPublic - 
     */
    public async getSessionToken(
        authorizationId: string,
        isPublic?: boolean
        ): Promise<Token.SessionToken> {

        const queryValues: any = {
            isPublic: isPublic
        };

        return this.beginRequest<Token.SessionToken>({
            apiVersion: "5.0-preview.1",
            routeTemplate: "_apis/Token/SessionTokens/{authorizationId}",
            routeValues: {
                authorizationId: authorizationId
            },
            queryParams: queryValues
        });
    }

    /**
     * @param isPublic - 
     * @param includePublicData - 
     */
    public async getSessionTokens(
        isPublic?: boolean,
        includePublicData?: boolean
        ): Promise<Token.SessionToken[]> {

        const queryValues: any = {
            isPublic: isPublic,
            includePublicData: includePublicData
        };

        return this.beginRequest<Token.SessionToken[]>({
            apiVersion: "5.0-preview.1",
            routeTemplate: "_apis/Token/SessionTokens/{authorizationId}",
            queryParams: queryValues
        });
    }

    /**
     * @param displayFilterOption - 
     * @param createdByOption - 
     * @param sortByOption - 
     * @param isSortAscending - 
     * @param startRowNumber - 
     * @param pageSize - 
     * @param pageRequestTimeStamp - 
     * @param isPublic - 
     * @param includePublicData - 
     */
    public async getSessionTokensPage(
        displayFilterOption: Token.DisplayFilterOptions,
        createdByOption: Token.CreatedByOptions,
        sortByOption: Token.SortByOptions,
        isSortAscending: boolean,
        startRowNumber: number,
        pageSize: number,
        pageRequestTimeStamp: string,
        isPublic?: boolean,
        includePublicData?: boolean
        ): Promise<Token.PagedSessionTokens> {

        const queryValues: any = {
            displayFilterOption: displayFilterOption,
            createdByOption: createdByOption,
            sortByOption: sortByOption,
            isSortAscending: isSortAscending,
            startRowNumber: startRowNumber,
            pageSize: pageSize,
            pageRequestTimeStamp: pageRequestTimeStamp,
            isPublic: isPublic,
            includePublicData: includePublicData
        };

        return this.beginRequest<Token.PagedSessionTokens>({
            apiVersion: "5.0-preview.1",
            routeTemplate: "_apis/Token/SessionTokens/{authorizationId}",
            queryParams: queryValues
        });
    }

    /**
     * @param publicData - 
     * @param remove - 
     */
    public async removePublicKey(
        publicData: Token.SshPublicKey,
        remove: boolean
        ): Promise<void> {

        const queryValues: any = {
            remove: remove
        };

        return this.beginRequest<void>({
            apiVersion: "5.0-preview.1",
            method: "POST",
            routeTemplate: "_apis/Token/SessionTokens/{authorizationId}",
            queryParams: queryValues,
            body: publicData
        });
    }

    /**
     */
    public async revokeAllSessionTokensOfUser(
        ): Promise<void> {

        return this.beginRequest<void>({
            apiVersion: "5.0-preview.1",
            method: "DELETE",
            routeTemplate: "_apis/Token/SessionTokens/{authorizationId}"
        });
    }

    /**
     * @param authorizationId - 
     * @param isPublic - 
     */
    public async revokeSessionToken(
        authorizationId: string,
        isPublic?: boolean
        ): Promise<void> {

        const queryValues: any = {
            isPublic: isPublic
        };

        return this.beginRequest<void>({
            apiVersion: "5.0-preview.1",
            method: "DELETE",
            routeTemplate: "_apis/Token/SessionTokens/{authorizationId}",
            routeValues: {
                authorizationId: authorizationId
            },
            queryParams: queryValues
        });
    }

}

export const TokenClientName = "Token-Admin.ITokenRestClient";

export function getTokenClient(pageContext: IVssPageContext, options?: IVssRestClientOptions): ITokenRestClient {
    return pageContext.getRestClient<ITokenRestClient>(TokenClientName, options);
}

RestClients.add(TokenClientName, { 
    factory: TokenRestClient,
    options: {
        serviceInstanceType: "951917ac-a960-4999-8464-e3f0aa25b381"
    }
});
